import { http } from './client';
import type { Bot, BotCreateInput, BotPatchInput, BotPromptSections } from './types';

export interface DefaultPrompts {
  ops: string;
  support: string;
  templates: { ops: BotPromptSections; support: BotPromptSections };
}

export interface PromptPreview {
  prompt: string;
  length: number;
  max: number;
}

export interface LlmModelInfo {
  id: string;
  backend: 'openai' | 'google-ai' | 'anthropic';
}

export interface ModelsResponse {
  default: { provider: string; model: string };
  models: LlmModelInfo[];
}

export const botsApi = {
  async list(): Promise<{ items: Bot[] }> {
    const res = await http.get<{ items: Bot[] }>('/v1/org/bots');
    return res.data;
  },
  async defaultPrompts(): Promise<DefaultPrompts> {
    const res = await http.get<DefaultPrompts>('/v1/org/bots/default-prompts');
    return res.data;
  },
  async previewPrompt(promptSections: BotPromptSections): Promise<PromptPreview> {
    const res = await http.post<PromptPreview>('/v1/org/bots/prompt-preview', { promptSections });
    return res.data;
  },
  async models(): Promise<ModelsResponse> {
    const res = await http.get<ModelsResponse>('/v1/org/models');
    return res.data;
  },
  async get(botId: string): Promise<Bot> {
    const res = await http.get<Bot>(`/v1/org/bots/${encodeURIComponent(botId)}`);
    return res.data;
  },
  async create(input: BotCreateInput): Promise<Bot> {
    const res = await http.post<Bot>('/v1/org/bots', input);
    return res.data;
  },
  async patch(botId: string, input: BotPatchInput): Promise<Bot> {
    const res = await http.patch<Bot>(`/v1/org/bots/${encodeURIComponent(botId)}`, input);
    return res.data;
  },
  async delete(botId: string): Promise<{ deleted: true; botId: string }> {
    const res = await http.delete<{ deleted: true; botId: string }>(
      `/v1/org/bots/${encodeURIComponent(botId)}`,
    );
    return res.data;
  },
};
